
import { useLoggedInUser as useCommonLoggedInUser } from "../../../../@common/auth/hooks/useLoggedInUser"

export const useLoggedInUser = useCommonLoggedInUser